var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKattanaPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 46,
    viewBox: "0 0 200 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1693 0H0V45.1693H45.1693V0Z",
    fill: "#D01F2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0954 24.2837H26.2316H18.711H9.58195L5.43652 29.9921H12.6854L6.63711 38.3057H15.4716L21.5878 29.9921H28.9499L33.0954 24.2837Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0737 20.8633H18.9601H26.4808H35.5872L39.7326 15.1548H32.3252L38.3281 6.84131H29.4936L23.468 15.1548H16.1965L12.0737 20.8633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9229 29.3123V16.5815H61.2981V21.3159H62.7479L65.8286 16.5815H69.6569L65.6474 22.5845L69.9287 29.3123H66.1231L62.9291 24.3967H61.2981V29.3123H57.9229Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0352 29.3123L82.501 16.5815H88.6852L92.151 29.3123H88.6852L88.0509 26.7752H83.1126L82.4784 29.3123H79.0352ZM83.8375 23.853H87.3034L86.216 19.6623H84.9475L83.8375 23.853Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.668 19.6849V16.5815H112.04V19.6849H108.031V29.335H104.655V19.6849H100.668Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.486 19.6849V16.5815H132.857V19.6849H128.848V29.335H125.473V19.6849H121.486Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.398 29.3123L144.864 16.5815H151.048L154.514 29.3123H151.048L150.414 26.7752H145.498L144.864 29.3123H141.398ZM146.223 23.853H149.689L148.601 19.6623H147.333L146.223 23.853Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.775 29.3123V16.5815H168.876L173.338 24.5779H173.519L173.247 22.9469V16.5815H176.623V29.3123H172.523L168.06 21.3159H167.879L168.151 22.9469V29.3123H164.775Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.884 29.3123L190.35 16.5815H196.534L200 29.3123H196.534L195.9 26.7752H190.984L190.35 29.3123H186.884ZM191.687 23.853H195.152L194.065 19.6623H192.797L191.687 23.853Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKattanaPremium);
export default __webpack_public_path__ + "static/media/kattana_premium.0754d617b530e2465d2cefd5da2f7ad3.svg";
export { ForwardRef as ReactComponent };